(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6619],{

/***/ 9388:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add/[[...currency]]",
      function () {
        return __webpack_require__(80086);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UnsupportedCurrencyFooter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62208);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89495);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73697);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11298);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48608);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65957);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19453);
/* harmony import */ var components_Layout_Row__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26830);
/* harmony import */ var components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77253);
/* harmony import */ var components_Logo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47269);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5305);
/* harmony import */ var utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94250);
/* harmony import */ var hooks_useActiveChainId__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76166);
/* harmony import */ var _hooks_Tokens__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31196);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 0;\n  width: 100%;\n  max-width: 400px;\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  color: ",
        ";\n  background-color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var DetailsFooter = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e6bb4bce-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
});
var UnsupportedModal = function(param) {
    var currencies = param.currencies, onDismiss = param.onDismiss;
    var chainId = (0,hooks_useActiveChainId__WEBPACK_IMPORTED_MODULE_8__/* .useActiveChainId */ .g)().chainId;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var tokens = chainId && currencies ? currencies.map(function(currency) {
        return (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_7__/* .wrappedCurrency */ .pu)(currency, chainId);
    }) : [];
    var unsupportedTokens = (0,_hooks_Tokens__WEBPACK_IMPORTED_MODULE_9__/* .useUnsupportedTokens */ .l6)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
        title: t("Unsupported Assets"),
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
            gap: "lg",
            children: [
                tokens.map(function(token) {
                    var ref;
                    return token && unsupportedTokens && Object.keys(unsupportedTokens).includes(token.address) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
                        gap: "10px",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_3__/* .AutoRow */ .BA, {
                                gap: "5px",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Logo__WEBPACK_IMPORTED_MODULE_5__/* .CurrencyLogo */ .Xw, {
                                        currency: token,
                                        size: "24px"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        children: token.symbol
                                    })
                                ]
                            }),
                            chainId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                external: true,
                                small: true,
                                color: "primaryDark",
                                href: (0,utils__WEBPACK_IMPORTED_MODULE_6__/* .getBlockExploreLink */ .C)(token.address, "address", chainId),
                                children: token.address
                            })
                        ]
                    }, (ref = token.address) === null || ref === void 0 ? void 0 : ref.concat("not-supported"));
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
                    gap: "lg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        children: t("Some assets are not available through this interface because they may not work well with our smart contract or we are unable to allow trading for legal reasons.")
                    })
                })
            ]
        })
    });
};
function UnsupportedCurrencyFooter(param) {
    var currencies = param.currencies;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UnsupportedModal, {
        currencies: currencies
    })), 1), onPresentModal = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DetailsFooter, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            variant: "text",
            onClick: onPresentModal,
            children: t("Read more about unsupported assets")
        })
    });
}


/***/ }),

/***/ 80086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _currency_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/tokens/src/index.ts + 10 modules
var src = __webpack_require__(13347);
// EXTERNAL MODULE: ./src/hooks/Tokens.ts
var Tokens = __webpack_require__(31196);
// EXTERNAL MODULE: ./src/hooks/useNativeCurrency.ts
var useNativeCurrency = __webpack_require__(5369);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/state/index.ts + 16 modules
var state = __webpack_require__(44291);
// EXTERNAL MODULE: ./src/state/mint/actions.ts
var actions = __webpack_require__(84709);
// EXTERNAL MODULE: ./src/utils/wagmi.ts + 8 modules
var wagmi = __webpack_require__(47945);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(10528);
// EXTERNAL MODULE: ../../packages/swap-sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(90902);
// EXTERNAL MODULE: ../../packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(98813);
// EXTERNAL MODULE: ../../packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(11298);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(95134);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(76660);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(89495);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(29420);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(48608);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(83931);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(20233);
// EXTERNAL MODULE: ./src/hooks/Trades.ts + 1 modules
var Trades = __webpack_require__(19061);
// EXTERNAL MODULE: ../../packages/localization/src/index.tsx + 6 modules
var localization_src = __webpack_require__(65957);
// EXTERNAL MODULE: ./src/components/UnsupportedCurrencyFooter.tsx
var UnsupportedCurrencyFooter = __webpack_require__(21834);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(76269);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(65342);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(70627);
// EXTERNAL MODULE: ./src/components/CommitButton.tsx
var CommitButton = __webpack_require__(49384);
// EXTERNAL MODULE: ./src/utils/getLpSymbol.ts
var getLpSymbol = __webpack_require__(50288);
// EXTERNAL MODULE: ./src/utils/calls/index.ts + 2 modules
var calls = __webpack_require__(72179);
// EXTERNAL MODULE: ./src/config/constants/supportChains.ts
var supportChains = __webpack_require__(20277);
// EXTERNAL MODULE: ./src/utils/transactionErrorToUserReadableMessage.ts
var transactionErrorToUserReadableMessage = __webpack_require__(38662);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(92794);
// EXTERNAL MODULE: ./src/state/swap/useLPApr.ts
var useLPApr = __webpack_require__(3601);
// EXTERNAL MODULE: ./src/components/Card/index.tsx
var Card = __webpack_require__(27156);
// EXTERNAL MODULE: ./src/components/Layout/Column.tsx
var Column = __webpack_require__(77253);
// EXTERNAL MODULE: ./src/components/CurrencyInputPanel/index.tsx
var CurrencyInputPanel = __webpack_require__(46317);
// EXTERNAL MODULE: ./src/components/App/index.tsx + 3 modules
var App = __webpack_require__(74939);
// EXTERNAL MODULE: ./src/components/PositionCard/index.tsx
var PositionCard = __webpack_require__(45366);
// EXTERNAL MODULE: ./src/components/Layout/Row.tsx
var Row = __webpack_require__(26830);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(39480);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(82055);
// EXTERNAL MODULE: ./src/hooks/useApproveCallback.ts
var useApproveCallback = __webpack_require__(74727);
// EXTERNAL MODULE: ./src/hooks/useTransactionDeadline.ts
var useTransactionDeadline = __webpack_require__(61558);
// EXTERNAL MODULE: ./src/state/mint/hooks.ts
var hooks = __webpack_require__(39113);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(52284);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(72135);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(5305);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 2 modules
var utils_exchange = __webpack_require__(43078);
// EXTERNAL MODULE: ./src/utils/maxAmountSpend.ts
var maxAmountSpend = __webpack_require__(6973);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(94250);
// EXTERNAL MODULE: ./src/components/Loader/Dots.tsx
var Dots = __webpack_require__(51991);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/PoolPriceBar.tsx







function PoolPriceBar(param) {
    var currencies = param.currencies, noLiquidity = param.noLiquidity, poolTokenPercentage = param.poolTokenPercentage, price = param.price;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
        gap: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
            justify: "space-around",
            gap: "4px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (ref5 = price === null || price === void 0 ? void 0 : price.toSignificant(6)) !== null && ref5 !== void 0 ? ref5 : "-"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            pt: 1,
                            children: t("%assetA% per %assetB%", {
                                assetA: (ref6 = (ref = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref === void 0 ? void 0 : ref.symbol) !== null && ref6 !== void 0 ? ref6 : "",
                                assetB: (ref7 = (ref1 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.symbol) !== null && ref7 !== void 0 ? ref7 : ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (ref8 = (ref2 = price === null || price === void 0 ? void 0 : price.invert()) === null || ref2 === void 0 ? void 0 : ref2.toSignificant(6)) !== null && ref8 !== void 0 ? ref8 : "-"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            pt: 1,
                            children: t("%assetA% per %assetB%", {
                                assetA: (ref9 = (ref3 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref3 === void 0 ? void 0 : ref3.symbol) !== null && ref9 !== void 0 ? ref9 : "",
                                assetB: (ref10 = (ref4 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref4 === void 0 ? void 0 : ref4.symbol) !== null && ref10 !== void 0 ? ref10 : ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            children: [
                                noLiquidity && price ? "100" : (ref11 = (poolTokenPercentage === null || poolTokenPercentage === void 0 ? void 0 : poolTokenPercentage.lessThan(exchange/* ONE_BIPS */.IS)) ? "<0.01" : poolTokenPercentage === null || poolTokenPercentage === void 0 ? void 0 : poolTokenPercentage.toFixed(2)) !== null && ref11 !== void 0 ? ref11 : "0",
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            pt: 1,
                            children: t("Share of Pool")
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var AddLiquidity_PoolPriceBar = (PoolPriceBar);

// EXTERNAL MODULE: ./src/views/Page.tsx
var Page = __webpack_require__(27023);
// EXTERNAL MODULE: ./src/components/TransactionConfirmationModal/index.tsx
var TransactionConfirmationModal = __webpack_require__(23475);
// EXTERNAL MODULE: ./src/state/burn/actions.ts
var burn_actions = __webpack_require__(80194);
// EXTERNAL MODULE: ../../node_modules/lodash/toNumber.js
var toNumber = __webpack_require__(7642);
var toNumber_default = /*#__PURE__*/__webpack_require__.n(toNumber);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(13670);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(62923);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(76903);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(47269);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/components/common.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var Dot = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-7c8deb2-0"
})(_templateObject());
var CircleSvg = function(_param) /*#__PURE__*/ {
    var _percent = _param.percent, percent = _percent === void 0 ? 1 : _percent, props = (0,_object_without_properties/* default */.Z)(_param, [
        "percent"
    ]);
    return (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "60px",
        height: "60px",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_i_1147_113741)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        r: "10",
                        cx: "10",
                        cy: "10",
                        fill: "#7645D9"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        r: "5",
                        cx: "10",
                        cy: "10",
                        fill: "transparent",
                        stroke: "#1FC7D4",
                        strokeWidth: "10",
                        strokeDasharray: "calc(".concat(percent * 100, "px * 31.4 / 100) 31.4"),
                        transform: "rotate(-90) translate(-20)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter0_i_1147_113741",
                    x: 0,
                    y: 0,
                    width: 60,
                    height: 60,
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            dy: -2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: -1,
                            k3: 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            in2: "shape",
                            result: "effect1_innerShadow_1147_113741"
                        })
                    ]
                })
            })
        ]
    }));
};
var Subtitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        fontSize: "12px",
        textTransform: "uppercase",
        bold: true,
        color: "secondary",
        children: children
    });
};
var PairDistribution = function(param) {
    var title = param.title, percent = param.percent, currencyA = param.currencyA, currencyB = param.currencyB, currencyAValue = param.currencyAValue, currencyBValue = param.currencyBValue, tooltipTargetRef = param.tooltipTargetRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        gap: "8px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    typeof percent !== "undefined" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: tooltipTargetRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleSvg, {
                            percent: percent,
                            mr: "34px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                        style: {
                            width: "100%"
                        },
                        children: [
                            currencyA && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                        gap: "4px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                                                bg: "primary"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                                currency: currencyA
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: currencyAValue
                                    })
                                ]
                            }),
                            currencyB && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                        gap: "4px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                                                bg: "secondary"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                                currency: currencyB
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: currencyBValue
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var AddLiquidityModalHeader = function(param) {
    var currencies = param.currencies, poolTokenPercentage = param.poolTokenPercentage, liquidityMinted = param.liquidityMinted, price = param.price, allowedSlippage = param.allowedSlippage, noLiquidity = param.noLiquidity, children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref9 = (0,useTooltip/* default */.Z)(t("Output is estimated. If the price changes by more than %slippage%% your transaction will revert.", {
        slippage: allowedSlippage / 100
    }), {
        placement: "auto"
    }), tooltip = ref9.tooltip, tooltipVisible = ref9.tooltipVisible, targetRef = ref9.targetRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        gap: "24px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                gap: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: t("You will receive")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* GreyCard */.h2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                    gap: "4px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* DoubleCurrencyLogo */.ge, {
                                            currency0: currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A],
                                            currency1: currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B],
                                            size: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "textSubtle",
                                            children: ((ref = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.symbol) && ((ref1 = currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.symbol) && (0,getLpSymbol/* getLPSymbol */.z)((ref2 = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.symbol, (ref3 = currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.symbol, (ref4 = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref4 === void 0 ? void 0 : ref4.chainId)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    ml: "8px",
                                    children: liquidityMinted === null || liquidityMinted === void 0 ? void 0 : liquidityMinted.toSignificant(6)
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: t("Your pool share")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        children: [
                            noLiquidity ? "100" : poolTokenPercentage === null || poolTokenPercentage === void 0 ? void 0 : poolTokenPercentage.toSignificant(4),
                            "%"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                gap: "8px",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                children: t("Rates")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: "1 ".concat((ref5 = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref5 === void 0 ? void 0 : ref5.symbol, " = ").concat(price === null || price === void 0 ? void 0 : price.toSignificant(4), " ").concat((ref6 = currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref6 === void 0 ? void 0 : ref6.symbol)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowBetween */.m0, {
                        style: {
                            justifyContent: "flex-end"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "1 ".concat((ref7 = currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref7 === void 0 ? void 0 : ref7.symbol, " = ").concat(price === null || price === void 0 ? void 0 : price.invert().toSignificant(4), " ").concat((ref8 = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref8 === void 0 ? void 0 : ref8.symbol)
                        })
                    })
                ]
            }),
            !noLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: t("Slippage Tolerance")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipText/* default */.Z, {
                        ref: targetRef,
                        children: [
                            allowedSlippage / 100,
                            "%"
                        ]
                    }),
                    tooltipVisible && tooltip
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/AddLiquidity/components/ConfirmAddLiquidityModal.tsx








var ConfirmAddLiquidityModal = function(param) {
    var title = param.title, onDismiss = param.onDismiss, customOnDismiss = param.customOnDismiss, attemptingTxn = param.attemptingTxn, hash = param.hash, pendingText = param.pendingText, price = param.price, currencies = param.currencies, noLiquidity = param.noLiquidity, allowedSlippage = param.allowedSlippage, parsedAmounts = param.parsedAmounts, liquidityErrorMessage = param.liquidityErrorMessage, onAdd = param.onAdd, poolTokenPercentage = param.poolTokenPercentage, liquidityMinted = param.liquidityMinted, currencyToAdd = param.currencyToAdd, isStable = param.isStable;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var percent = 0.5;
    // Calculate distribution percentage for display
    if (isStable && parsedAmounts[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A] && parsedAmounts[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) {
        var amountCurrencyA = toNumber_default()(parsedAmounts[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A].toSignificant(6));
        var amountCurrencyB = toNumber_default()(parsedAmounts[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B].toSignificant(6));
        percent = amountCurrencyA / (amountCurrencyA + amountCurrencyB);
    }
    var modalHeader = (0,react.useCallback)(function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddLiquidityModalHeader, {
            allowedSlippage: allowedSlippage,
            currencies: currencies,
            liquidityMinted: liquidityMinted,
            poolTokenPercentage: poolTokenPercentage,
            price: price,
            noLiquidity: noLiquidity,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PairDistribution, {
                title: t("Input"),
                percent: percent,
                currencyA: currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A],
                currencyAValue: (ref = parsedAmounts[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.toSignificant(6),
                currencyB: currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B],
                currencyBValue: (ref1 = parsedAmounts[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)
            })
        });
    }, [
        allowedSlippage,
        percent,
        currencies,
        liquidityMinted,
        noLiquidity,
        parsedAmounts,
        poolTokenPercentage,
        price,
        t
    ]);
    var modalBottom = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            width: "100%",
            onClick: onAdd,
            mt: "20px",
            children: noLiquidity ? t("Create Pool & Supply") : t("Confirm Supply")
        });
    }, [
        noLiquidity,
        onAdd,
        t
    ]);
    var confirmationContent = (0,react.useCallback)(function() {
        return liquidityErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionErrorContent */.ht, {
            onDismiss: onDismiss,
            message: liquidityErrorMessage
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* ConfirmationModalContent */.pM, {
            topContent: modalHeader,
            bottomContent: modalBottom
        });
    }, [
        onDismiss,
        modalBottom,
        modalHeader,
        liquidityErrorMessage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* default */.ZP, {
        minWidth: [
            "100%",
            ,
            "420px"
        ],
        title: title,
        onDismiss: onDismiss,
        customOnDismiss: customOnDismiss,
        attemptingTxn: attemptingTxn,
        currencyToAdd: currencyToAdd,
        hash: hash,
        content: confirmationContent,
        pendingText: pendingText
    });
};
/* harmony default export */ var components_ConfirmAddLiquidityModal = (ConfirmAddLiquidityModal);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(52180);
// EXTERNAL MODULE: ./src/hooks/useTotalSupply.ts
var useTotalSupply = __webpack_require__(34508);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(76166);
// EXTERNAL MODULE: ./src/views/AddLiquidity/components/ZapErrorMessage.tsx
var ZapErrorMessage = __webpack_require__(97794);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/components/ConfirmZapInModal.tsx
















var clamp = function(num, min, max) {
    return Math.min(Math.max(num, min), max);
};
var ConfirmZapInModal = function(param) {
    var title = param.title, onDismiss = param.onDismiss, customOnDismiss = param.customOnDismiss, attemptingTxn = param.attemptingTxn, hash = param.hash, pendingText = param.pendingText, price = param.price, currencies = param.currencies, zapSwapTokenField = param.zapSwapTokenField, zapSwapOutTokenField = param.zapSwapOutTokenField, allowedSlippage = param.allowedSlippage, parsedAmounts = param.parsedAmounts, liquidityErrorMessage = param.liquidityErrorMessage, onAdd = param.onAdd, poolTokenPercentage = param.poolTokenPercentage, liquidityMinted = param.liquidityMinted, pair = param.pair, zapInEstimated = param.zapInEstimated, rebalancing = param.rebalancing, zapMode = param.zapMode, toggleZapMode = param.toggleZapMode;
    var ref, ref1, ref2, ref3;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var totalPoolTokens = (0,useTotalSupply/* default */.Z)(pair.liquidityToken);
    var swapInCurrencyAmount = parsedAmounts[zapSwapTokenField];
    var swapOutCurrencyAmount = parsedAmounts[zapSwapOutTokenField];
    var ref4 = (0,useTooltip/* default */.Z)(swapInCurrencyAmount && !swapOutCurrencyAmount ? t("There is no %token1% input. Half of %token0% input is converted into %token1% to add liquidity.", {
        token0: (ref = currencies[zapSwapTokenField]) === null || ref === void 0 ? void 0 : ref.symbol,
        token1: (ref1 = currencies[zapSwapOutTokenField]) === null || ref1 === void 0 ? void 0 : ref1.symbol
    }) : t("There is not enough %token1% input to match 50/50. Some of %token0% will be converted to %token1%", {
        token0: (ref2 = currencies[zapSwapTokenField]) === null || ref2 === void 0 ? void 0 : ref2.symbol,
        token1: (ref3 = currencies[zapSwapOutTokenField]) === null || ref3 === void 0 ? void 0 : ref3.symbol
    }), {
        placement: "auto-start"
    }), targetRef = ref4.targetRef, tooltip = ref4.tooltip, tooltipVisible = ref4.tooltipVisible;
    var ref5 = (0,_sliced_to_array/* default */.Z)(!!pair && !!totalPoolTokens && !!liquidityMinted && // this condition is a short-circuit in the case where useTokenBalance updates sooner than useTotalSupply
    dist/* JSBI.greaterThanOrEqual */.QA.greaterThanOrEqual(totalPoolTokens.quotient, liquidityMinted.quotient) ? [
        pair.getLiquidityValue(pair.token0, totalPoolTokens, liquidityMinted, false),
        pair.getLiquidityValue(pair.token1, totalPoolTokens, liquidityMinted, false), 
    ] : [
        undefined,
        undefined
    ], 2), token0Deposited = ref5[0], token1Deposited = ref5[1];
    var swapInTokenAmount = (0,react.useMemo)(function() {
        return zapInEstimated && dist/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount((0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[zapSwapTokenField], chainId), zapInEstimated.swapAmountIn.toString());
    }, [
        chainId,
        currencies,
        zapInEstimated,
        zapSwapTokenField
    ]);
    var swapOutTokenAmount = (0,react.useMemo)(function() {
        return (zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut) && dist/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount((0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[zapSwapOutTokenField], chainId), zapInEstimated.swapAmountOut.toString());
    }, [
        chainId,
        currencies,
        zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut,
        zapSwapOutTokenField
    ]);
    var inputPercent = (0,react.useMemo)(function() {
        return swapInCurrencyAmount && swapOutCurrencyAmount ? clamp(// TODO: avoid use number
        +swapInCurrencyAmount.toExact() / +swapOutCurrencyAmount.toExact() / (+pair.priceOf(swapOutCurrencyAmount.currency.wrapped).toSignificant() + +swapInCurrencyAmount.toExact() / +swapOutCurrencyAmount.toExact()), 0.05, 0.95) : swapInCurrencyAmount && !swapOutCurrencyAmount ? 1 : undefined;
    }, [
        pair,
        swapInCurrencyAmount,
        swapOutCurrencyAmount
    ]);
    var tokenDeposited = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, zapSwapTokenField, (swapInTokenAmount === null || swapInTokenAmount === void 0 ? void 0 : swapInTokenAmount.currency) && (pair === null || pair === void 0 ? void 0 : pair.token0) ? pair.token0.equals(swapInTokenAmount.currency) ? token0Deposited : token1Deposited : undefined), (0,_define_property/* default */.Z)(_obj, zapSwapOutTokenField, (swapOutTokenAmount === null || swapOutTokenAmount === void 0 ? void 0 : swapOutTokenAmount.currency) && (pair === null || pair === void 0 ? void 0 : pair.token1) ? pair.token1.equals(swapOutTokenAmount.currency) ? token1Deposited : token0Deposited : undefined), _obj;
    }, [
        pair.token0,
        pair.token1,
        swapInTokenAmount === null || swapInTokenAmount === void 0 ? void 0 : swapInTokenAmount.currency,
        swapOutTokenAmount === null || swapOutTokenAmount === void 0 ? void 0 : swapOutTokenAmount.currency,
        token0Deposited,
        token1Deposited,
        zapSwapOutTokenField,
        zapSwapTokenField, 
    ]);
    var modalHeader = (0,react.useCallback)(function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddLiquidityModalHeader, {
            allowedSlippage: allowedSlippage,
            currencies: currencies,
            liquidityMinted: liquidityMinted,
            poolTokenPercentage: poolTokenPercentage,
            price: price,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PairDistribution, {
                    title: t("Input"),
                    percent: inputPercent,
                    currencyA: swapInCurrencyAmount ? currencies[zapSwapTokenField] : undefined,
                    currencyAValue: swapInCurrencyAmount === null || swapInCurrencyAmount === void 0 ? void 0 : swapInCurrencyAmount.toSignificant(6),
                    currencyB: swapOutCurrencyAmount ? currencies[zapSwapOutTokenField] : undefined,
                    currencyBValue: swapOutCurrencyAmount === null || swapOutCurrencyAmount === void 0 ? void 0 : swapOutCurrencyAmount.toSignificant(6)
                }),
                swapOutTokenAmount && swapInTokenAmount && currencies[zapSwapTokenField] && currencies[zapSwapOutTokenField] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    justify: "center",
                    gap: "16px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                            color: "textSubtle"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                            gap: "6px",
                            justify: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                    gap: "2px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: swapInTokenAmount === null || swapInTokenAmount === void 0 ? void 0 : swapInTokenAmount.toSignificant(6)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                            currency: currencies[zapSwapTokenField]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: currencies[zapSwapTokenField].symbol
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: t("to")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                    gap: "2px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: swapOutTokenAmount === null || swapOutTokenAmount === void 0 ? void 0 : swapOutTokenAmount.toSignificant(6)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                            currency: currencies[zapSwapOutTokenField]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: currencies[zapSwapOutTokenField].symbol
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                            color: "textSubtle"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    gap: "4px",
                    children: [
                        tooltipVisible && tooltip,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PairDistribution, {
                            tooltipTargetRef: targetRef,
                            title: t("Pooled"),
                            percent: 0.5,
                            currencyA: currencies[zapSwapTokenField],
                            currencyAValue: tokenDeposited === null || tokenDeposited === void 0 ? void 0 : (ref = tokenDeposited[zapSwapTokenField]) === null || ref === void 0 ? void 0 : ref.toSignificant(6),
                            currencyB: currencies[zapSwapOutTokenField],
                            currencyBValue: tokenDeposited === null || tokenDeposited === void 0 ? void 0 : (ref1 = tokenDeposited[zapSwapOutTokenField]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)
                        })
                    ]
                })
            ]
        });
    }, [
        allowedSlippage,
        currencies,
        liquidityMinted,
        poolTokenPercentage,
        price,
        t,
        inputPercent,
        swapInCurrencyAmount,
        zapSwapTokenField,
        swapOutCurrencyAmount,
        zapSwapOutTokenField,
        swapOutTokenAmount,
        swapInTokenAmount,
        tooltip,
        tooltipVisible,
        targetRef,
        tokenDeposited, 
    ]);
    var modalBottom = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            width: "100%",
            onClick: onAdd,
            mt: "20px",
            children: t("Confirm Supply")
        });
    }, [
        onAdd,
        t
    ]);
    var confirmationContent = (0,react.useCallback)(function() {
        return liquidityErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ZapErrorMessage/* ZapErrorMessages */.p, {
                    isSingleToken: !rebalancing,
                    zapMode: zapMode,
                    toggleZapMode: toggleZapMode,
                    onModalDismiss: onDismiss
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionErrorContent */.ht, {
                    onDismiss: onDismiss,
                    message: liquidityErrorMessage
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* ConfirmationModalContent */.pM, {
            topContent: modalHeader,
            bottomContent: modalBottom
        });
    }, [
        liquidityErrorMessage,
        rebalancing,
        zapMode,
        toggleZapMode,
        onDismiss,
        modalHeader,
        modalBottom
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* default */.ZP, {
        minWidth: [
            "100%",
            ,
            "420px"
        ],
        title: title,
        onDismiss: onDismiss,
        customOnDismiss: customOnDismiss,
        attemptingTxn: attemptingTxn,
        currencyToAdd: pair === null || pair === void 0 ? void 0 : pair.liquidityToken,
        hash: hash,
        content: confirmationContent,
        pendingText: pendingText
    });
};
/* harmony default export */ var components_ConfirmZapInModal = (ConfirmZapInModal);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Layouts/FlexGap.tsx
var FlexGap = __webpack_require__(59482);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Card/CardFooter.tsx
var CardFooter = __webpack_require__(67252);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/ArrowDropDown.tsx
var ArrowDropDown = __webpack_require__(20345);
// EXTERNAL MODULE: ./src/components/SearchModal/CurrencySearchModal.tsx + 11 modules
var CurrencySearchModal = __webpack_require__(79051);
// EXTERNAL MODULE: ../../packages/utils/formatBalance.ts
var formatBalance = __webpack_require__(18426);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var wallet_hooks = __webpack_require__(33472);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(36695);
// EXTERNAL MODULE: ../../packages/wagmi/dist/index.mjs
var wagmi_dist = __webpack_require__(9270);
;// CONCATENATED MODULE: ./src/components/CurrencySelect/index.tsx





function CurrencySelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 16px;\n  box-shadow: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 10px;\n  background: ",
        ";\n  transition: border-radius 0.15s;\n"
    ]);
    CurrencySelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  position: relative;\n  background: ",
        ";\n  border-radius: 10px;\n  height: 40px;\n  min-width: 136px;\n  user-select: none;\n  z-index: 20;\n\n  ",
        " {\n    min-width: 168px;\n  }\n\n  .down-icon {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var DropDownHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9398228-0"
})(CurrencySelect_templateObject(), function(param) {
    var theme = param.theme;
    return theme.shadows.inset;
}, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.input;
});
var DropDownContainer = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-c9398228-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var CurrencySelect = function(_param) {
    var onCurrencySelect = _param.onCurrencySelect, selectedCurrency = _param.selectedCurrency, otherSelectedCurrency = _param.otherSelectedCurrency, showCommonBases = _param.showCommonBases, commonBasesType = _param.commonBasesType, hideBalance = _param.hideBalance, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCurrencySelect",
        "selectedCurrency",
        "otherSelectedCurrency",
        "showCommonBases",
        "commonBasesType",
        "hideBalance"
    ]);
    var account = (0,wagmi_dist/* useWeb3React */.Ge)().account;
    var selectedCurrencyBalance = (0,wallet_hooks/* useCurrencyBalance */._h)(account !== null && account !== void 0 ? account : undefined, !hideBalance && selectedCurrency ? selectedCurrency : undefined);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySearchModal/* default */.Z, {
        onCurrencySelect: onCurrencySelect,
        selectedCurrency: selectedCurrency,
        otherSelectedCurrency: otherSelectedCurrency,
        showCommonBases: showCommonBases,
        commonBasesType: commonBasesType
    })), 1), onPresentCurrencyModal = ref[0];
    var price = (0,useBUSDPrice/* default */.ZP)(selectedCurrencyBalance && selectedCurrency ? selectedCurrency : undefined);
    var quoted = selectedCurrencyBalance && (price === null || price === void 0 ? void 0 : price.quote(selectedCurrencyBalance));
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropDownContainer, {
                p: 0,
                onClick: onPresentCurrencyModal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            id: "pair",
                            color: !selectedCurrency ? "text" : undefined,
                            children: !selectedCurrency ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: t("Select")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                        currency: selectedCurrency,
                                        size: "24px",
                                        style: {
                                            marginRight: "8px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        id: "pair",
                                        bold: true,
                                        children: selectedCurrency && selectedCurrency.symbol && selectedCurrency.symbol.length > 20 ? "".concat(selectedCurrency.symbol.slice(0, 4), "...").concat(selectedCurrency.symbol.slice(selectedCurrency.symbol.length - 5, selectedCurrency.symbol.length)) : selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.symbol
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropDown/* default */.Z, {
                        color: "text",
                        className: "down-icon"
                    })
                ]
            }),
            account && !!selectedCurrency && !hideBalance && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                        justify: "space-between",
                        gap: "2px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: "textSubtle",
                                fontSize: "12px",
                                children: [
                                    t("Balance"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                children: (ref1 = selectedCurrencyBalance === null || selectedCurrencyBalance === void 0 ? void 0 : selectedCurrencyBalance.toSignificant(6)) !== null && ref1 !== void 0 ? ref1 : t("Loading")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                            Number.isFinite(+(quoted === null || quoted === void 0 ? void 0 : quoted.toExact())) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                children: [
                                    "~$",
                                    (0,formatBalance/* formatNumber */.uf)(+quoted.toExact())
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/utils/formatInfoNumbers.ts
var formatInfoNumbers = __webpack_require__(84785);
// EXTERNAL MODULE: ./src/components/SearchModal/types.ts
var types = __webpack_require__(34188);
// EXTERNAL MODULE: ./src/utils/currencyId.ts
var currencyId = __webpack_require__(36099);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/useCurrencySelectRoute.ts





var useCurrencySelectRoute = function() {
    var native = (0,useNativeCurrency/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(router.query.currency || [], 2), currencyIdA = ref[0], currencyIdB = ref[1];
    var handleCurrencyASelect = (0,react.useCallback)(function(currencyA_) {
        var newCurrencyIdA = (0,currencyId/* default */.Z)(currencyA_);
        if (newCurrencyIdA === currencyIdB) {
            router.replace("/add/".concat(currencyIdB, "/").concat(currencyIdA), undefined, {
                shallow: true
            });
        } else if (currencyIdB) {
            router.replace("/add/".concat(newCurrencyIdA, "/").concat(currencyIdB), undefined, {
                shallow: true
            });
        } else {
            router.replace("/add/".concat(newCurrencyIdA), undefined, {
                shallow: true
            });
        }
    }, [
        currencyIdB,
        router,
        currencyIdA
    ]);
    var handleCurrencyBSelect = (0,react.useCallback)(function(currencyB_) {
        var newCurrencyIdB = (0,currencyId/* default */.Z)(currencyB_);
        if (currencyIdA === newCurrencyIdB) {
            if (currencyIdB) {
                router.replace("/add/".concat(currencyIdB, "/").concat(newCurrencyIdB), undefined, {
                    shallow: true
                });
            } else {
                router.replace("/add/".concat(newCurrencyIdB), undefined, {
                    shallow: true
                });
            }
        } else {
            router.replace("/add/".concat(currencyIdA || native.symbol, "/").concat(newCurrencyIdB), undefined, {
                shallow: true
            });
        }
    }, [
        currencyIdA,
        router,
        currencyIdB,
        native
    ]);
    return {
        handleCurrencyASelect: handleCurrencyASelect,
        handleCurrencyBSelect: handleCurrencyBSelect
    };
};

;// CONCATENATED MODULE: ./src/views/AddLiquidity/ChoosePair.tsx















function ChoosePair(param) {
    var currencyA = param.currencyA, currencyB = param.currencyB, error = param.error, onNext = param.onNext;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isValid = !error;
    var ref = useCurrencySelectRoute(), handleCurrencyASelect = ref.handleCurrencyASelect, handleCurrencyBSelect = ref.handleCurrencyBSelect;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,usePairs/* usePair */.yX)(currencyA, currencyB), 2), pair = ref1[1];
    var poolData = (0,useLPApr/* useLPApr */.a)(pair);
    var ref2 = (0,useTooltip/* default */.Z)(t("Based on last 7 days' performance. Does not account for impermanent loss"), {
        placement: "bottom"
    }), targetRef = ref2.targetRef, tooltip = ref2.tooltip, tooltipVisible = ref2.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(App/* AppHeader */.t, {
                title: t("Add Liquidity"),
                subtitle: t("Receive LP tokens and earn 0.17% trading fees"),
                helper: t("Liquidity providers earn a 0.17% trading fee on all trades made for that token pair, proportional to their share of the liquidity pool."),
                backTo: "/liquidity"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textTransform: "uppercase",
                            color: "secondary",
                            bold: true,
                            small: true,
                            pb: "24px",
                            children: t("Choose a valid pair")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexGap/* default */.Z, {
                            gap: "4px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelect, {
                                    id: "add-liquidity-select-tokena",
                                    selectedCurrency: currencyA,
                                    onCurrencySelect: handleCurrencyASelect,
                                    showCommonBases: true,
                                    commonBasesType: types/* CommonBasesType.LIQUIDITY */.L0.LIQUIDITY
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                    color: "textSubtle"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelect, {
                                    id: "add-liquidity-select-tokenb",
                                    selectedCurrency: currencyB,
                                    onCurrencySelect: handleCurrencyBSelect,
                                    showCommonBases: true,
                                    commonBasesType: types/* CommonBasesType.LIQUIDITY */.L0.LIQUIDITY
                                })
                            ]
                        }),
                        pair && poolData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                            mt: "24px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                                    ref: targetRef,
                                    bold: true,
                                    fontSize: "12px",
                                    color: "secondary",
                                    children: t("LP reward APR")
                                }),
                                tooltipVisible && tooltip,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    bold: true,
                                    color: "primary",
                                    children: [
                                        (0,formatInfoNumbers/* formatAmount */.d)(poolData.lpApr7d),
                                        "%"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardFooter/* default */.Z, {
                children: !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                    width: "100%"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
                    "data-test": "choose-pair-next",
                    width: "100%",
                    variant: !isValid ? "danger" : "primary",
                    onClick: onNext,
                    disabled: !isValid,
                    children: error !== null && error !== void 0 ? error : t("Add Liquidity")
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/CurrencyInputPanel/ZapCheckbox.tsx
var ZapCheckbox = __webpack_require__(82708);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/index.tsx
























































var Steps;
(function(Steps) {
    Steps[Steps["Choose"] = 0] = "Choose";
    Steps[Steps["Add"] = 1] = "Add";
})(Steps || (Steps = {}));
var zapAddress = (0,addressHelpers/* getZapAddress */._M)();
function AddLiquidity(param) {
    var currencyA = param.currencyA, currencyB = param.currencyB;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
    var router = (0,next_router.useRouter)();
    var ref28 = (0,useActiveWeb3React/* default */.Z)(), account = ref28.account, chainId = ref28.chainId, isWrongNetwork = ref28.isWrongNetwork;
    var addPair = (0,user_hooks/* usePairAdder */.uB)();
    var ref29 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useZapModeManager */.$f)(), 1), zapMode = ref29[0];
    var expertMode = (0,user_hooks/* useIsExpertMode */.LO)();
    var ref30 = (0,react.useState)(true), temporarilyZapMode = ref30[0], setTemporarilyZapMode = ref30[1];
    var ref31 = (0,react.useState)(Steps.Choose), steps = ref31[0], setSteps = ref31[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    (0,react.useEffect)(function() {
        if (router.query.step === "1") {
            setSteps(Steps.Add);
        }
    }, [
        router.query
    ]);
    var zapModeStatus = (0,react.useMemo)(function() {
        return !!zapMode && temporarilyZapMode;
    }, [
        zapMode,
        temporarilyZapMode
    ]);
    // mint state
    var ref32 = (0,hooks/* useMintState */.OY)(), independentField = ref32.independentField, typedValue = ref32.typedValue, otherTypedValue = ref32.otherTypedValue;
    var ref33 = (0,hooks/* useDerivedMintInfo */.Qw)(currencyA !== null && currencyA !== void 0 ? currencyA : undefined, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), dependentField = ref33.dependentField, currencies = ref33.currencies, pair = ref33.pair, pairState = ref33.pairState, currencyBalances = ref33.currencyBalances, mintParsedAmounts = ref33.parsedAmounts, price = ref33.price, noLiquidity = ref33.noLiquidity, liquidityMinted = ref33.liquidityMinted, poolTokenPercentage = ref33.poolTokenPercentage, error = ref33.error, addError = ref33.addError;
    var poolData = (0,useLPApr/* useLPApr */.a)(pair);
    var ref34 = (0,useTooltip/* default */.Z)(t("Based on last 7 days' performance. Does not account for impermanent loss"), {
        placement: "bottom"
    }), targetRef = ref34.targetRef, tooltip = ref34.tooltip, tooltipVisible = ref34.tooltipVisible;
    var ref35 = (0,hooks/* useMintActionHandlers */.OA)(noLiquidity), onFieldAInput = ref35.onFieldAInput, onFieldBInput = ref35.onFieldBInput;
    // modal and loading
    var ref36 = (0,react.useState)({
        attemptingTxn: false,
        liquidityErrorMessage: undefined,
        txHash: undefined
    }), ref37 = ref36[0], attemptingTxn = ref37.attemptingTxn, liquidityErrorMessage = ref37.liquidityErrorMessage, txHash = ref37.txHash, setLiquidityState = ref36[1];
    // Zap state
    var ref38 = (0,react.useState)(true), zapTokenToggleA = ref38[0], setZapTokenToggleA = ref38[1];
    var ref39 = (0,react.useState)(true), zapTokenToggleB = ref39[0], setZapTokenToggleB = ref39[1];
    var zapTokenCheckedA = zapTokenToggleA && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref = currencyBalances[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.greaterThan(0));
    var zapTokenCheckedB = zapTokenToggleB && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref1 = currencyBalances[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.greaterThan(0));
    // txn values
    var deadline = (0,useTransactionDeadline/* default */.Z)() // custom from users settings
    ;
    var ref40 // custom from users
     = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref40[0];
    // get the max amounts user can add
    var maxAmounts = [
        actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
        actions/* Field.CURRENCY_B */.gN.CURRENCY_B
    ].reduce(function(accumulator, field) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulator), (0,_define_property/* default */.Z)({}, field, (0,maxAmountSpend/* maxAmountSpend */.i)(currencyBalances[field])));
    }, {});
    var canZap = (0,react.useMemo)(function() {
        return !!zapModeStatus && !noLiquidity && supportChains/* SUPPORT_ZAP.includes */.K.includes(chainId) && !(pair && dist/* JSBI.lessThan */.QA.lessThan(pair.reserve0.quotient, dist/* MINIMUM_LIQUIDITY */.Xh) || pair && dist/* JSBI.lessThan */.QA.lessThan(pair.reserve1.quotient, dist/* MINIMUM_LIQUIDITY */.Xh));
    }, [
        chainId,
        noLiquidity,
        pair,
        zapModeStatus
    ]);
    var ref41 = useCurrencySelectRoute(), handleCurrencyASelect = ref41.handleCurrencyASelect, handleCurrencyBSelect = ref41.handleCurrencyBSelect;
    var _ref = (0,hooks/* useZapIn */.eM)({
        pair: pair,
        canZap: canZap,
        currencyA: currencyA,
        currencyB: currencyB,
        currencyBalances: currencyBalances,
        zapTokenCheckedA: zapTokenCheckedA,
        zapTokenCheckedB: zapTokenCheckedB,
        maxAmounts: maxAmounts
    }), zapInEstimating = _ref.zapInEstimating, rebalancing = _ref.rebalancing, zapIn = (0,_object_without_properties/* default */.Z)(_ref, [
        "zapInEstimating",
        "rebalancing"
    ]);
    var parsedAmounts = canZap ? zapIn.parsedAmounts : mintParsedAmounts;
    var preferZapInstead = canZap && !zapIn.noNeedZap;
    var ref42;
    // get formatted amounts
    var formattedAmounts = (0,react.useMemo)(function() {
        var ref;
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, independentField, canZap && (independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A && !zapTokenCheckedA || independentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B && !zapTokenCheckedB) ? "" : typedValue), (0,_define_property/* default */.Z)(_obj, dependentField, noLiquidity ? otherTypedValue : (ref42 = (ref = parsedAmounts[dependentField]) === null || ref === void 0 ? void 0 : ref.toSignificant(6)) !== null && ref42 !== void 0 ? ref42 : ""), _obj;
    }, [
        canZap,
        dependentField,
        independentField,
        noLiquidity,
        otherTypedValue,
        parsedAmounts,
        typedValue,
        zapTokenCheckedA,
        zapTokenCheckedB, 
    ]);
    var atMaxAmounts = [
        actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
        actions/* Field.CURRENCY_B */.gN.CURRENCY_B
    ].reduce(function(accumulator, field) {
        var ref;
        var _field;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulator), (0,_define_property/* default */.Z)({}, field, (ref = maxAmounts[field]) === null || ref === void 0 ? void 0 : ref.equalTo((_field = parsedAmounts[field]) !== null && _field !== void 0 ? _field : "0")));
    }, {});
    // check whether the user has approved the router on the tokens
    var ref43 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallback */.qL)(parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], preferZapInstead ? zapAddress : exchange/* ROUTER_ADDRESS */.bR[chainId]), 2), approvalA = ref43[0], approveACallback = ref43[1];
    var ref44 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallback */.qL)(parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B], preferZapInstead ? zapAddress : exchange/* ROUTER_ADDRESS */.bR[chainId]), 2), approvalB = ref44[0], approveBCallback = ref44[1];
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var routerContract = (0,utils_exchange/* useRouterContract */.Ti)();
    function onAdd() {
        return _onAdd.apply(this, arguments);
    }
    function _onAdd() {
        _onAdd = (0,_async_to_generator/* default */.Z)(function() {
            var parsedAmountA, parsedAmountB, _obj, amountsMin, estimate, method, args, value, ref, ref1, tokenBIsNative, ref2, ref3, ref4, ref5, ref6;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!chainId || !account || !routerContract) return [
                            2
                        ];
                        parsedAmountA = mintParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], parsedAmountB = mintParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
                        if (!parsedAmountA || !parsedAmountB || !currencyA || !currencyB || !deadline) {
                            return [
                                2
                            ];
                        }
                        amountsMin = (_obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, (0,utils_exchange/* calculateSlippageAmount */.uc)(parsedAmountA, noLiquidity ? 0 : allowedSlippage)[0]), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, (0,utils_exchange/* calculateSlippageAmount */.uc)(parsedAmountB, noLiquidity ? 0 : allowedSlippage)[0]), _obj);
                        if ((currencyA === null || currencyA === void 0 ? void 0 : currencyA.isNative) || (currencyB === null || currencyB === void 0 ? void 0 : currencyB.isNative)) {
                            ;
                            tokenBIsNative = currencyB === null || currencyB === void 0 ? void 0 : currencyB.isNative;
                            estimate = routerContract.estimateGas.addLiquidityETH;
                            method = routerContract.addLiquidityETH;
                            ;
                            args = [
                                (ref2 = (ref = tokenBIsNative ? currencyA : currencyB) === null || ref === void 0 ? void 0 : (ref1 = ref.wrapped) === null || ref1 === void 0 ? void 0 : ref1.address) !== null && ref2 !== void 0 ? ref2 : "",
                                (tokenBIsNative ? parsedAmountA : parsedAmountB).quotient.toString(),
                                amountsMin[tokenBIsNative ? actions/* Field.CURRENCY_A */.gN.CURRENCY_A : actions/* Field.CURRENCY_B */.gN.CURRENCY_B].toString(),
                                amountsMin[tokenBIsNative ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A].toString(),
                                account,
                                deadline.toHexString(), 
                            ];
                            value = bignumber/* BigNumber.from */.O$.from((tokenBIsNative ? parsedAmountB : parsedAmountA).quotient.toString());
                        } else {
                            ;
                            estimate = routerContract.estimateGas.addLiquidity;
                            method = routerContract.addLiquidity;
                            ;
                            args = [
                                (ref5 = currencyA === null || currencyA === void 0 ? void 0 : (ref3 = currencyA.wrapped) === null || ref3 === void 0 ? void 0 : ref3.address) !== null && ref5 !== void 0 ? ref5 : "",
                                (ref6 = currencyB === null || currencyB === void 0 ? void 0 : (ref4 = currencyB.wrapped) === null || ref4 === void 0 ? void 0 : ref4.address) !== null && ref6 !== void 0 ? ref6 : "",
                                parsedAmountA.quotient.toString(),
                                parsedAmountB.quotient.toString(),
                                amountsMin[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].toString(),
                                amountsMin[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].toString(),
                                account,
                                deadline.toHexString(), 
                            ];
                            value = null;
                        }
                        setLiquidityState({
                            attemptingTxn: true,
                            liquidityErrorMessage: undefined,
                            txHash: undefined
                        });
                        return [
                            4,
                            estimate.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                                value ? {
                                    value: value
                                } : {}
                            ])).then(function(estimatedGasLimit) {
                                return method.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value ? {
                                        value: value
                                    } : {}), {
                                        gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGasLimit),
                                        gasPrice: gasPrice
                                    })
                                ])).then(function(response) {
                                    var ref, ref1, ref2, ref3;
                                    setLiquidityState({
                                        attemptingTxn: false,
                                        liquidityErrorMessage: undefined,
                                        txHash: response.hash
                                    });
                                    var symbolA = (ref = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.symbol;
                                    var amountA = (ref1 = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(3);
                                    var symbolB = (ref2 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref2 === void 0 ? void 0 : ref2.symbol;
                                    var amountB = (ref3 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.toSignificant(3);
                                    addTransaction(response, {
                                        summary: "Add ".concat(amountA, " ").concat(symbolA, " and ").concat(amountB, " ").concat(symbolB),
                                        translatableSummary: {
                                            text: "Add %amountA% %symbolA% and %amountB% %symbolB%",
                                            data: {
                                                amountA: amountA,
                                                symbolA: symbolA,
                                                amountB: amountB,
                                                symbolB: symbolB
                                            }
                                        },
                                        type: "add-liquidity"
                                    });
                                    if (pair) {
                                        addPair(pair);
                                    }
                                });
                            }).catch(function(err) {
                                if (err && err.code !== 4001) {
                                    (0,sentry/* logError */.H)(err);
                                    console.error("Add Liquidity failed", err, args, value);
                                }
                                setLiquidityState({
                                    attemptingTxn: false,
                                    liquidityErrorMessage: err && err.code !== 4001 ? t("Add liquidity failed: %message%", {
                                        message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(err, t)
                                    }) : undefined,
                                    txHash: undefined
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _onAdd.apply(this, arguments);
    }
    var ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52;
    var pendingText = preferZapInstead ? t("Zapping %amountA% %symbolA% and %amountB% %symbolB%", {
        amountA: (ref45 = (ref2 = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.toSignificant(6)) !== null && ref45 !== void 0 ? ref45 : "0",
        symbolA: (ref46 = (ref3 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref3 === void 0 ? void 0 : ref3.symbol) !== null && ref46 !== void 0 ? ref46 : "",
        amountB: (ref47 = (ref4 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref4 === void 0 ? void 0 : ref4.toSignificant(6)) !== null && ref47 !== void 0 ? ref47 : "0",
        symbolB: (ref48 = (ref5 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref5 === void 0 ? void 0 : ref5.symbol) !== null && ref48 !== void 0 ? ref48 : ""
    }) : t("Supplying %amountA% %symbolA% and %amountB% %symbolB%", {
        amountA: (ref49 = (ref6 = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref6 === void 0 ? void 0 : ref6.toSignificant(6)) !== null && ref49 !== void 0 ? ref49 : "",
        symbolA: (ref50 = (ref7 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref7 === void 0 ? void 0 : ref7.symbol) !== null && ref50 !== void 0 ? ref50 : "",
        amountB: (ref51 = (ref8 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref8 === void 0 ? void 0 : ref8.toSignificant(6)) !== null && ref51 !== void 0 ? ref51 : "",
        symbolB: (ref52 = (ref9 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref9 === void 0 ? void 0 : ref9.symbol) !== null && ref52 !== void 0 ? ref52 : ""
    });
    var handleDismissConfirmation = (0,react.useCallback)(function() {
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onFieldAInput("");
        }
    }, [
        onFieldAInput,
        txHash
    ]);
    var addIsUnsupported = (0,Trades/* useIsTransactionUnsupported */.mP)(currencies === null || currencies === void 0 ? void 0 : currencies.CURRENCY_A, currencies === null || currencies === void 0 ? void 0 : currencies.CURRENCY_B);
    var addIsWarning = (0,Trades/* useIsTransactionWarning */.uK)(currencies === null || currencies === void 0 ? void 0 : currencies.CURRENCY_A, currencies === null || currencies === void 0 ? void 0 : currencies.CURRENCY_B);
    var zapContract = (0,useContract/* useZapContract */.n9)(true);
    var ref53 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmAddLiquidityModal, {
        title: noLiquidity ? t("You are creating a pool") : t("You will receive"),
        customOnDismiss: handleDismissConfirmation,
        attemptingTxn: attemptingTxn,
        hash: txHash,
        pendingText: pendingText,
        currencyToAdd: pair === null || pair === void 0 ? void 0 : pair.liquidityToken,
        allowedSlippage: allowedSlippage,
        onAdd: onAdd,
        parsedAmounts: parsedAmounts,
        currencies: currencies,
        liquidityErrorMessage: liquidityErrorMessage,
        price: price,
        noLiquidity: noLiquidity,
        poolTokenPercentage: poolTokenPercentage,
        liquidityMinted: liquidityMinted
    }), true, true, "addLiquidityModal"), 1), onPresentAddLiquidityModal = ref53[0];
    function onZapIn() {
        return _onZapIn.apply(this, arguments);
    }
    function _onZapIn() {
        _onZapIn = (0,_async_to_generator/* default */.Z)(function() {
            var ref, method, args, value, summary, translatableSummary, minAmountOut, ref1, ref2, ref3, ref4, maxAmountIn, amountA, symbolA, amountB, symbolB, tokenBIsBNB, ref5, amount, symbol, ref6, amount1, symbol1, lpSymbol;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!canZap || !parsedAmounts || !zapIn.zapInEstimated || !chainId || !zapContract) {
                    return [
                        2
                    ];
                }
                minAmountOut = zapIn.zapInEstimated.swapAmountOut.mul(10000 - allowedSlippage).div(10000);
                if (rebalancing) {
                    ;
                    maxAmountIn = zapIn.zapInEstimated.swapAmountIn.mul(10000 + allowedSlippage).div(10000);
                    amountA = (ref1 = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(3);
                    symbolA = (ref2 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.symbol;
                    amountB = (ref3 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.toSignificant(3);
                    symbolB = (ref4 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref4 === void 0 ? void 0 : ref4.symbol;
                    summary = "Zap ".concat(amountA, " ").concat(symbolA, " and ").concat(amountB, " ").concat(symbolB);
                    translatableSummary = {
                        text: "Zap %amountA% %symbolA% and %amountB% %symbolB%",
                        data: {
                            amountA: amountA,
                            symbolA: symbolA,
                            amountB: amountB,
                            symbolB: symbolB
                        }
                    };
                    if ((currencyA === null || currencyA === void 0 ? void 0 : currencyA.isNative) || (currencyB === null || currencyB === void 0 ? void 0 : currencyB.isNative)) {
                        tokenBIsBNB = currencyB === null || currencyB === void 0 ? void 0 : currencyB.isNative;
                        method = "zapInBNBRebalancing";
                        args = [
                            (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[tokenBIsBNB ? actions/* Field.CURRENCY_A */.gN.CURRENCY_A : actions/* Field.CURRENCY_B */.gN.CURRENCY_B], chainId).address,
                            parsedAmounts[tokenBIsBNB ? actions/* Field.CURRENCY_A */.gN.CURRENCY_A : actions/* Field.CURRENCY_B */.gN.CURRENCY_B].quotient.toString(),
                            pair.liquidityToken.address,
                            maxAmountIn,
                            minAmountOut,
                            zapIn.zapInEstimated.isToken0Sold && !tokenBIsBNB
                        ];
                        value = parsedAmounts[tokenBIsBNB ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A].quotient.toString();
                    } else {
                        method = "zapInTokenRebalancing";
                        args = [
                            (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], chainId).address,
                            (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B], chainId).address,
                            parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].quotient.toString(),
                            parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].quotient.toString(),
                            pair.liquidityToken.address,
                            maxAmountIn,
                            minAmountOut,
                            zapIn.zapInEstimated.isToken0Sold
                        ];
                    }
                } else if ((ref = currencies[zapIn.swapTokenField]) === null || ref === void 0 ? void 0 : ref.isNative) {
                    ;
                    method = "zapInBNB";
                    args = [
                        pair.liquidityToken.address,
                        minAmountOut
                    ];
                    amount = (ref5 = parsedAmounts[zapIn.swapTokenField]) === null || ref5 === void 0 ? void 0 : ref5.toSignificant(3);
                    symbol = (0,getLpSymbol/* getLPSymbol */.z)(pair.token0.symbol, pair.token1.symbol, chainId);
                    summary = "Zap in ".concat(amount, " BNB for ").concat(symbol);
                    translatableSummary = {
                        text: "Zap in %amount% BNB for %symbol%",
                        data: {
                            amount: amount,
                            symbol: symbol
                        }
                    };
                    value = parsedAmounts[zapIn.swapTokenField].quotient.toString();
                } else {
                    ;
                    method = "zapInToken";
                    args = [
                        (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[zapIn.swapTokenField], chainId).address,
                        parsedAmounts[zapIn.swapTokenField].quotient.toString(),
                        pair.liquidityToken.address,
                        minAmountOut, 
                    ];
                    amount1 = (ref6 = parsedAmounts[zapIn.swapTokenField]) === null || ref6 === void 0 ? void 0 : ref6.toSignificant(3);
                    symbol1 = currencies[zapIn.swapTokenField].symbol;
                    lpSymbol = (0,getLpSymbol/* getLPSymbol */.z)(pair.token0.symbol, pair.token1.symbol, chainId);
                    summary = "Zap in ".concat(amount1, " ").concat(symbol1, " for ").concat(lpSymbol);
                    translatableSummary = {
                        text: "Zap in %amount% %symbol% for %lpSymbol%",
                        data: {
                            amount: amount1,
                            symbol: symbol1,
                            lpSymbol: lpSymbol
                        }
                    };
                }
                setLiquidityState({
                    attemptingTxn: true,
                    liquidityErrorMessage: undefined,
                    txHash: undefined
                });
                (0,calls/* callWithEstimateGas */.Zj)(zapContract, method, args, value ? {
                    value: value,
                    gasPrice: gasPrice
                } : {
                    gasPrice: gasPrice
                }).then(function(response) {
                    setLiquidityState({
                        attemptingTxn: false,
                        liquidityErrorMessage: undefined,
                        txHash: response.hash
                    });
                    addTransaction(response, {
                        summary: summary,
                        translatableSummary: translatableSummary,
                        type: "add-liquidity"
                    });
                    if (pair) {
                        addPair(pair);
                    }
                }).catch(function(err) {
                    if (err && err.code !== 4001) {
                        (0,sentry/* logError */.H)(err);
                        console.error("Add Liquidity failed", err, args, value);
                    }
                    setLiquidityState({
                        attemptingTxn: false,
                        liquidityErrorMessage: err && err.code !== 4001 ? t("Add liquidity failed: %message%", {
                            message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(err, t)
                        }) : undefined,
                        txHash: undefined
                    });
                });
                return [
                    2
                ];
            });
        });
        return _onZapIn.apply(this, arguments);
    }
    var ref54 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmZapInModal, {
        title: t("You will receive"),
        customOnDismiss: handleDismissConfirmation,
        attemptingTxn: attemptingTxn,
        hash: txHash,
        pendingText: pendingText,
        pair: pair,
        allowedSlippage: allowedSlippage,
        onAdd: onZapIn,
        parsedAmounts: parsedAmounts,
        currencies: currencies,
        liquidityErrorMessage: liquidityErrorMessage,
        price: price,
        poolTokenPercentage: zapIn.poolTokenPercentage,
        liquidityMinted: zapIn.liquidityMinted,
        zapSwapTokenField: zapIn.swapTokenField,
        zapSwapOutTokenField: zapIn.swapOutTokenField,
        zapInEstimated: zapIn.zapInEstimated,
        rebalancing: rebalancing,
        zapMode: zapModeStatus,
        toggleZapMode: setTemporarilyZapMode
    }), true, true, "zapInModal"), 1), onPresentZapInModal = ref54[0];
    var handleEnableZap = function() {
        if (!zapMode) {
            setTemporarilyZapMode(!zapMode);
        }
    };
    var isValid = !error;
    var errorText = error;
    if (preferZapInstead) {
        isValid = !error && !zapIn.error;
        errorText = error !== null && error !== void 0 ? error : zapIn.error;
    } else {
        isValid = !error && !addError;
        errorText = error !== null && error !== void 0 ? error : addError;
    }
    var buttonDisabled = !isValid || (zapIn.parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] || !preferZapInstead && zapTokenCheckedA) && approvalA !== useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED || (zapIn.parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] || !preferZapInstead && zapTokenCheckedB) && approvalB !== useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED || zapIn.priceSeverity > 3 && preferZapInstead;
    var showFieldAApproval = (zapTokenCheckedA || !preferZapInstead) && (approvalA === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approvalA === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING);
    var showFieldBApproval = (zapTokenCheckedB || !preferZapInstead) && (approvalB === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approvalB === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING);
    var shouldShowApprovalGroup = (showFieldAApproval || showFieldBApproval) && isValid;
    var oneCurrencyIsWNATIVE = Boolean(chainId && (currencyA && currencyA.equals(dist/* WNATIVE */.FX[chainId]) || currencyB && currencyB.equals(dist/* WNATIVE */.FX[chainId])));
    var noAnyInputAmount = !parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && !parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
    var showAddLiquidity = !!currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && !!currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] && steps === Steps.Add || !canZap;
    var showZapWarning = preferZapInstead && !noAnyInputAmount && (!rebalancing && !(!zapTokenCheckedA && !zapTokenCheckedB) || rebalancing && zapIn.priceSeverity > 3);
    var showReduceZapTokenButton = preferZapInstead && (zapIn.priceSeverity > 3 || zapIn.zapInEstimatedError) && maxAmounts[zapIn.swapTokenField];
    var showRebalancingConvert = !showZapWarning && !noAnyInputAmount && !showReduceZapTokenButton && preferZapInstead && zapIn.isDependentAmountGreaterThanMaxAmount && rebalancing;
    var showZapIsAvailable = !zapMode && !showZapWarning && !noAnyInputAmount && (!zapTokenCheckedA || !zapTokenCheckedB) && !noLiquidity && !(pair && dist/* JSBI.lessThan */.QA.lessThan(pair.reserve0.quotient, dist/* MINIMUM_LIQUIDITY */.Xh) || pair && dist/* JSBI.lessThan */.QA.lessThan(pair.reserve1.quotient, dist/* MINIMUM_LIQUIDITY */.Xh));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(App/* AppBody */.j, {
                children: [
                    !showAddLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChoosePair, {
                        error: error,
                        currencyA: currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                        currencyB: currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                        onNext: function() {
                            return setSteps(Steps.Add);
                        }
                    }),
                    showAddLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(App/* AppHeader */.t, {
                                title: ((ref10 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref10 === void 0 ? void 0 : ref10.symbol) && ((ref11 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref11 === void 0 ? void 0 : ref11.symbol) ? "".concat((0,getLpSymbol/* getLPSymbol */.z)(currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].symbol, currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].symbol, chainId)) : t("Add Liquidity"),
                                subtitle: t("Receive LP tokens and earn 0.17% trading fees"),
                                helper: t("Liquidity providers earn a 0.17% trading fee on all trades made for that token pair, proportional to their share of the liquidity pool."),
                                backTo: canZap ? function() {
                                    return setSteps(Steps.Choose);
                                } : "/liquidity"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                    gap: "20px",
                                    children: [
                                        noLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* ColumnCenter */.lg, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                                variant: "warning",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            bold: true,
                                                            mb: "8px",
                                                            children: t("You are the first liquidity provider.")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            mb: "8px",
                                                            children: t("The ratio of tokens you add will set the price of this pool.")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            children: t("Once you are happy with the rate click supply to review.")
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                            disableCurrencySelect: canZap,
                                            showBUSD: true,
                                            onInputBlur: canZap ? zapIn.onInputBlurOnce : undefined,
                                            error: zapIn.priceSeverity > 3 && zapIn.swapTokenField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
                                            disabled: canZap && !zapTokenCheckedA,
                                            beforeButton: canZap && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZapCheckbox/* ZapCheckbox */.y, {
                                                disabled: currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref12 = currencyBalances[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref12 === void 0 ? void 0 : ref12.equalTo(0),
                                                checked: zapTokenCheckedA,
                                                onChange: function(e) {
                                                    setZapTokenToggleA(e.target.checked);
                                                }
                                            }),
                                            onCurrencySelect: handleCurrencyASelect,
                                            zapStyle: canZap ? "zap" : "noZap",
                                            value: formattedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                                            onUserInput: onFieldAInput,
                                            onPercentInput: function(percent) {
                                                if (maxAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) {
                                                    var ref;
                                                    var ref1;
                                                    onFieldAInput((ref1 = (ref = maxAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.multiply(new dist/* Percent */.gG(percent, 100)).toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                                }
                                            },
                                            onMax: function() {
                                                var ref;
                                                var ref1;
                                                onFieldAInput((ref1 = (ref = maxAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                            },
                                            showQuickInputButton: true,
                                            showMaxButton: !atMaxAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                                            currency: currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                                            id: "add-liquidity-input-tokena",
                                            showCommonBases: true,
                                            commonBasesType: types/* CommonBasesType.LIQUIDITY */.L0.LIQUIDITY
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* ColumnCenter */.lg, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                                width: "16px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                            showBUSD: true,
                                            onInputBlur: canZap ? zapIn.onInputBlurOnce : undefined,
                                            disabled: canZap && !zapTokenCheckedB,
                                            error: zapIn.priceSeverity > 3 && zapIn.swapTokenField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B,
                                            beforeButton: canZap && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZapCheckbox/* ZapCheckbox */.y, {
                                                disabled: currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref13 = currencyBalances[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref13 === void 0 ? void 0 : ref13.equalTo(0),
                                                checked: zapTokenCheckedB,
                                                onChange: function(e) {
                                                    setZapTokenToggleB(e.target.checked);
                                                }
                                            }),
                                            onCurrencySelect: handleCurrencyBSelect,
                                            disableCurrencySelect: canZap,
                                            zapStyle: canZap ? "zap" : "noZap",
                                            value: formattedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                                            onUserInput: onFieldBInput,
                                            onPercentInput: function(percent) {
                                                if (maxAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) {
                                                    var ref;
                                                    var ref1;
                                                    onFieldBInput((ref1 = (ref = maxAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref === void 0 ? void 0 : ref.multiply(new dist/* Percent */.gG(percent, 100)).toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                                }
                                            },
                                            onMax: function() {
                                                var ref;
                                                var ref1;
                                                onFieldBInput((ref1 = (ref = maxAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                            },
                                            showQuickInputButton: true,
                                            showMaxButton: !atMaxAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                                            currency: currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                                            id: "add-liquidity-input-tokenb",
                                            showCommonBases: true,
                                            commonBasesType: types/* CommonBasesType.LIQUIDITY */.L0.LIQUIDITY
                                        }),
                                        showZapWarning && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                            variant: zapIn.priceSeverity > 3 ? "danger" : "warning",
                                            children: zapIn.priceSeverity > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                                                children: [
                                                    t("Price Impact Too High."),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: t("Reduce amount of %token% to maximum limit", {
                                                            token: (ref14 = currencies[zapIn.swapTokenField]) === null || ref14 === void 0 ? void 0 : ref14.symbol
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: t("No %token% input.", {
                                                            token: (ref15 = currencies[zapIn.swapOutTokenField]) === null || ref15 === void 0 ? void 0 : ref15.symbol
                                                        })
                                                    }),
                                                    " ",
                                                    t("Some of your %token0% will be converted to %token1%.", {
                                                        token0: (ref16 = currencies[zapIn.swapTokenField]) === null || ref16 === void 0 ? void 0 : ref16.symbol,
                                                        token1: (ref17 = currencies[zapIn.swapOutTokenField]) === null || ref17 === void 0 ? void 0 : ref17.symbol
                                                    })
                                                ]
                                            })
                                        }),
                                        showReduceZapTokenButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                                            style: {
                                                margin: "auto"
                                            },
                                            onClick: function() {
                                                return zapIn.convertToMaxZappable();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "secondary",
                                                scale: "sm",
                                                children: t("Reduce %token%", {
                                                    token: (ref18 = currencies[zapIn.swapTokenField]) === null || ref18 === void 0 ? void 0 : ref18.symbol
                                                })
                                            })
                                        }),
                                        showZapIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                            variant: "warning",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                                                children: [
                                                    t("Zap allows you to add liquidity with only 1 single token. Click"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        p: "0 4px",
                                                        scale: "sm",
                                                        variant: "text",
                                                        height: "auto",
                                                        onClick: handleEnableZap,
                                                        children: t("here")
                                                    }),
                                                    t("to try.")
                                                ]
                                            })
                                        }),
                                        showRebalancingConvert && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                            variant: "warning",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: t("Not enough %token%.", {
                                                                token: (ref19 = currencies[zapIn.swapOutTokenField]) === null || ref19 === void 0 ? void 0 : ref19.symbol
                                                            })
                                                        }),
                                                        " ",
                                                        zapIn.gasOverhead ? t("Some of your %token0% will be converted to %token1% before adding liquidity, but this may cause higher gas fees.", {
                                                            token0: (ref20 = currencies[zapIn.swapTokenField]) === null || ref20 === void 0 ? void 0 : ref20.symbol,
                                                            token1: (ref21 = currencies[zapIn.swapOutTokenField]) === null || ref21 === void 0 ? void 0 : ref21.symbol
                                                        }) : t("Some of your %token0% will be converted to %token1%.", {
                                                            token0: (ref22 = currencies[zapIn.swapTokenField]) === null || ref22 === void 0 ? void 0 : ref22.symbol,
                                                            token1: (ref23 = currencies[zapIn.swapOutTokenField]) === null || ref23 === void 0 ? void 0 : ref23.symbol
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        showRebalancingConvert && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                                            style: {
                                                margin: "auto"
                                            },
                                            onClick: function() {
                                                if (dependentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A) {
                                                    var ref;
                                                    var ref1;
                                                    onFieldAInput((ref1 = (ref = maxAmounts[dependentField]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                                } else {
                                                    var ref2;
                                                    var ref3;
                                                    onFieldBInput((ref3 = (ref2 = maxAmounts[dependentField]) === null || ref2 === void 0 ? void 0 : ref2.toExact()) !== null && ref3 !== void 0 ? ref3 : "");
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "secondary",
                                                scale: "sm",
                                                children: t("Don’t convert")
                                            })
                                        }),
                                        currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] && pairState !== usePairs/* PairState.INVALID */._G.INVALID && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* LightCard */.hl, {
                                                padding: "0px",
                                                borderRadius: "20px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowBetween */.m0, {
                                                        padding: "1rem",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            fontSize: "14px",
                                                            children: noLiquidity ? t("Initial prices and pool share") : t("Prices and pool share")
                                                        })
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* LightCard */.hl, {
                                                        padding: "1rem",
                                                        borderRadius: "20px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddLiquidity_PoolPriceBar, {
                                                            currencies: currencies,
                                                            poolTokenPercentage: preferZapInstead ? zapIn.poolTokenPercentage : poolTokenPercentage,
                                                            noLiquidity: noLiquidity,
                                                            price: price
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    bold: true,
                                                    fontSize: "12px",
                                                    color: "secondary",
                                                    children: t("Slippage Tolerance")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    bold: true,
                                                    color: "primary",
                                                    children: [
                                                        allowedSlippage / 100,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        }),
                                        pair && poolData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                                                    ref: targetRef,
                                                    bold: true,
                                                    fontSize: "12px",
                                                    color: "secondary",
                                                    children: t("LP reward APR")
                                                }),
                                                tooltipVisible && tooltip,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    bold: true,
                                                    color: "primary",
                                                    children: [
                                                        (0,formatInfoNumbers/* formatAmount */.d)(poolData.lpApr7d),
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        }),
                                        addIsUnsupported || addIsWarning ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            disabled: true,
                                            mb: "4px",
                                            children: t("Unsupported Asset")
                                        }) : !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {}) : isWrongNetwork ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                            gap: "md",
                                            children: [
                                                shouldShowApprovalGroup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                                    style: {
                                                        gap: "8px"
                                                    },
                                                    children: [
                                                        showFieldAApproval && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            onClick: approveACallback,
                                                            disabled: approvalA === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING,
                                                            width: "100%",
                                                            children: approvalA === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                                                                children: t("Enabling %asset%", {
                                                                    asset: (ref24 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref24 === void 0 ? void 0 : ref24.symbol
                                                                })
                                                            }) : t("Enable %asset%", {
                                                                asset: (ref25 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref25 === void 0 ? void 0 : ref25.symbol
                                                            })
                                                        }),
                                                        showFieldBApproval && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            onClick: approveBCallback,
                                                            disabled: approvalB === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING,
                                                            width: "100%",
                                                            children: approvalB === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                                                                children: t("Enabling %asset%", {
                                                                    asset: (ref26 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref26 === void 0 ? void 0 : ref26.symbol
                                                                })
                                                            }) : t("Enable %asset%", {
                                                                asset: (ref27 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref27 === void 0 ? void 0 : ref27.symbol
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
                                                    isLoading: preferZapInstead && zapInEstimating,
                                                    variant: !isValid || zapIn.priceSeverity > 2 ? "danger" : "primary",
                                                    onClick: function() {
                                                        if (preferZapInstead) {
                                                            setLiquidityState({
                                                                attemptingTxn: false,
                                                                liquidityErrorMessage: undefined,
                                                                txHash: undefined
                                                            });
                                                            onPresentZapInModal();
                                                            return;
                                                        }
                                                        if (expertMode) {
                                                            onAdd();
                                                        } else {
                                                            setLiquidityState({
                                                                attemptingTxn: false,
                                                                liquidityErrorMessage: undefined,
                                                                txHash: undefined
                                                            });
                                                            onPresentAddLiquidityModal();
                                                        }
                                                    },
                                                    disabled: buttonDisabled,
                                                    children: errorText || t("Supply")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            !(addIsUnsupported || addIsWarning) ? pair && !noLiquidity && pairState !== usePairs/* PairState.INVALID */._G.INVALID ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                style: {
                    minWidth: "20rem",
                    width: "100%",
                    maxWidth: "400px",
                    marginTop: "1rem"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionCard/* MinimalPositionCard */.WP, {
                    showUnwrapped: oneCurrencyIsWNATIVE,
                    pair: pair
                })
            }) : null : /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsupportedCurrencyFooter/* default */.Z, {
                currencies: [
                    currencies.CURRENCY_A,
                    currencies.CURRENCY_B
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/views/Swap/StableSwap/hooks/useStableConfig.ts + 3 modules
var useStableConfig = __webpack_require__(86849);
// EXTERNAL MODULE: ./src/views/AddLiquidity/AddStableLiquidity/hooks/useStableLPDerivedMintInfo.tsx
var useStableLPDerivedMintInfo = __webpack_require__(70343);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/AddStableLiquidity/index.tsx








































function AddStableLiquidity(param) {
    var currencyA = param.currencyA, currencyB = param.currencyB;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,useActiveWeb3React/* default */.Z)(), account = ref10.account, chainId = ref10.chainId, isWrongNetwork = ref10.isWrongNetwork;
    var expertMode = (0,user_hooks/* useIsExpertMode */.LO)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    // mint state
    var ref11 = (0,hooks/* useMintState */.OY)(), independentField = ref11.independentField, typedValue = ref11.typedValue, otherTypedValue = ref11.otherTypedValue;
    var ref12 = (0,useStableLPDerivedMintInfo/* useStableLPDerivedMintInfo */.L)(currencyA !== null && currencyA !== void 0 ? currencyA : undefined, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), dependentField = ref12.dependentField, currencies = ref12.currencies, pair = ref12.pair, pairState = ref12.pairState, currencyBalances = ref12.currencyBalances, parsedAmounts = ref12.parsedAmounts, price = ref12.price, noLiquidity = ref12.noLiquidity, liquidityMinted = ref12.liquidityMinted, poolTokenPercentage = ref12.poolTokenPercentage, error = ref12.error, addError = ref12.addError;
    var ref13 = (0,hooks/* useMintActionHandlers */.OA)(true), onFieldAInput = ref13.onFieldAInput, onFieldBInput = ref13.onFieldBInput;
    // modal and loading
    var ref14 = (0,react.useState)({
        attemptingTxn: false,
        liquidityErrorMessage: undefined,
        txHash: undefined
    }), ref15 = ref14[0], attemptingTxn = ref15.attemptingTxn, liquidityErrorMessage = ref15.liquidityErrorMessage, txHash = ref15.txHash, setLiquidityState = ref14[1];
    // txn values
    var ref16 // custom from users
     = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref16[0];
    // get the max amounts user can add
    var maxAmounts = [
        actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
        actions/* Field.CURRENCY_B */.gN.CURRENCY_B
    ].reduce(function(accumulator, field) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulator), (0,_define_property/* default */.Z)({}, field, (0,maxAmountSpend/* maxAmountSpend */.i)(currencyBalances[field])));
    }, {});
    var ref17 = useCurrencySelectRoute(), handleCurrencyASelect = ref17.handleCurrencyASelect, handleCurrencyBSelect = ref17.handleCurrencyBSelect;
    // get formatted amounts
    var formattedAmounts = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, independentField, typedValue), (0,_define_property/* default */.Z)(_obj, dependentField, otherTypedValue), _obj;
    }, [
        dependentField,
        independentField,
        otherTypedValue,
        typedValue
    ]);
    var atMaxAmounts = [
        actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
        actions/* Field.CURRENCY_B */.gN.CURRENCY_B
    ].reduce(function(accumulator, field) {
        var ref;
        var _field;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulator), (0,_define_property/* default */.Z)({}, field, (ref = maxAmounts[field]) === null || ref === void 0 ? void 0 : ref.equalTo((_field = parsedAmounts[field]) !== null && _field !== void 0 ? _field : "0")));
    }, {});
    var ref18 = (0,react.useContext)(useStableConfig/* StableConfigContext */.UA), stableSwapContract = ref18.stableSwapContract, stableSwapConfig = ref18.stableSwapConfig;
    // check whether the user has approved tokens for addling LPs
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallback */.qL)(parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], stableSwapContract === null || stableSwapContract === void 0 ? void 0 : stableSwapContract.address), 2), approvalA = ref19[0], approveACallback = ref19[1];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallback */.qL)(parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B], stableSwapContract === null || stableSwapContract === void 0 ? void 0 : stableSwapContract.address), 2), approvalB = ref20[0], approveBCallback = ref20[1];
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    function onAdd() {
        return _onAdd.apply(this, arguments);
    }
    function _onAdd() {
        _onAdd = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, parsedAmountA, parsedAmountB, lpMintedSlippage, estimate, method, tokenAmounts, args, value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!chainId || !account || !stableSwapContract) return [
                            2
                        ];
                        parsedAmountA = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], parsedAmountB = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
                        if (!parsedAmountA || !parsedAmountB || !currencyA || !currencyB) {
                            return [
                                2
                            ];
                        }
                        lpMintedSlippage = (0,utils_exchange/* calculateSlippageAmount */.uc)(liquidityMinted, noLiquidity ? 0 : allowedSlippage)[0];
                        estimate = stableSwapContract.estimateGas.add_liquidity;
                        method = stableSwapContract.add_liquidity;
                        tokenAmounts = (stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : (ref = stableSwapConfig.token0) === null || ref === void 0 ? void 0 : ref.address) === (parsedAmountA === null || parsedAmountA === void 0 ? void 0 : (ref1 = parsedAmountA.currency) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.wrapped) === null || ref2 === void 0 ? void 0 : ref2.address) ? [
                            parsedAmountA === null || parsedAmountA === void 0 ? void 0 : (ref3 = parsedAmountA.quotient) === null || ref3 === void 0 ? void 0 : ref3.toString(),
                            parsedAmountB === null || parsedAmountB === void 0 ? void 0 : (ref4 = parsedAmountB.quotient) === null || ref4 === void 0 ? void 0 : ref4.toString()
                        ] : [
                            parsedAmountB === null || parsedAmountB === void 0 ? void 0 : (ref5 = parsedAmountB.quotient) === null || ref5 === void 0 ? void 0 : ref5.toString(),
                            parsedAmountA === null || parsedAmountA === void 0 ? void 0 : (ref6 = parsedAmountA.quotient) === null || ref6 === void 0 ? void 0 : ref6.toString()
                        ];
                        args = [
                            tokenAmounts,
                            lpMintedSlippage === null || lpMintedSlippage === void 0 ? void 0 : lpMintedSlippage.toString()
                        ];
                        value = null;
                        setLiquidityState({
                            attemptingTxn: true,
                            liquidityErrorMessage: undefined,
                            txHash: undefined
                        });
                        return [
                            4,
                            estimate.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                                value ? {
                                    value: value
                                } : {}
                            ])).then(function(estimatedGasLimit) {
                                return method.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value ? {
                                        value: value
                                    } : {}), {
                                        gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGasLimit),
                                        gasPrice: gasPrice
                                    })
                                ])).then(function(response) {
                                    var ref, ref1, ref2, ref3;
                                    setLiquidityState({
                                        attemptingTxn: false,
                                        liquidityErrorMessage: undefined,
                                        txHash: response.hash
                                    });
                                    var symbolA = (ref = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.symbol;
                                    var amountA = (ref1 = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(3);
                                    var symbolB = (ref2 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref2 === void 0 ? void 0 : ref2.symbol;
                                    var amountB = (ref3 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.toSignificant(3);
                                    addTransaction(response, {
                                        summary: "Add ".concat(amountA, " ").concat(symbolA, " and ").concat(amountB, " ").concat(symbolB),
                                        translatableSummary: {
                                            text: "Add %amountA% %symbolA% and %amountB% %symbolB%",
                                            data: {
                                                amountA: amountA,
                                                symbolA: symbolA,
                                                amountB: amountB,
                                                symbolB: symbolB
                                            }
                                        },
                                        type: "add-liquidity"
                                    });
                                });
                            }).catch(function(err) {
                                if (err && err.code !== 4001) {
                                    (0,sentry/* logError */.H)(err);
                                    console.error("Add Liquidity failed", err, args, value);
                                }
                                setLiquidityState({
                                    attemptingTxn: false,
                                    liquidityErrorMessage: err && err.code !== 4001 ? t("Add liquidity failed: %message%", {
                                        message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(err, t)
                                    }) : undefined,
                                    txHash: undefined
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _onAdd.apply(this, arguments);
    }
    var ref21, ref22, ref23, ref24;
    var pendingText = t("Supplying %amountA% %symbolA% and %amountB% %symbolB%", {
        amountA: (ref21 = (ref = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.toSignificant(6)) !== null && ref21 !== void 0 ? ref21 : "",
        symbolA: (ref22 = (ref1 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.symbol) !== null && ref22 !== void 0 ? ref22 : "",
        amountB: (ref23 = (ref2 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref2 === void 0 ? void 0 : ref2.toSignificant(6)) !== null && ref23 !== void 0 ? ref23 : "",
        symbolB: (ref24 = (ref3 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.symbol) !== null && ref24 !== void 0 ? ref24 : ""
    });
    var handleDismissConfirmation = (0,react.useCallback)(function() {
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onFieldAInput("");
            onFieldBInput("");
        }
    }, [
        onFieldAInput,
        onFieldBInput,
        txHash
    ]);
    var ref25 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmAddLiquidityModal, {
        title: noLiquidity ? t("You are creating a pool") : t("You will receive"),
        customOnDismiss: handleDismissConfirmation,
        attemptingTxn: attemptingTxn,
        hash: txHash,
        pendingText: pendingText,
        currencyToAdd: pair === null || pair === void 0 ? void 0 : pair.liquidityToken,
        allowedSlippage: allowedSlippage,
        onAdd: onAdd,
        parsedAmounts: parsedAmounts,
        currencies: currencies,
        liquidityErrorMessage: liquidityErrorMessage,
        price: price,
        noLiquidity: noLiquidity,
        poolTokenPercentage: poolTokenPercentage,
        liquidityMinted: liquidityMinted,
        isStable: true
    }), true, true, "addLiquidityModal"), 1), onPresentAddLiquidityModal = ref25[0];
    var isValid = !error;
    var errorText = error;
    isValid = !error && !addError;
    errorText = error !== null && error !== void 0 ? error : addError;
    var buttonDisabled = !isValid || approvalA !== useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED || approvalB !== useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED;
    var showFieldAApproval = approvalA === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approvalA === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING;
    var showFieldBApproval = approvalB === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approvalB === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING;
    var shouldShowApprovalGroup = (showFieldAApproval || showFieldBApproval) && isValid;
    var oneCurrencyIsWNATIVE = Boolean(chainId && (currencyA && currencyA.equals(dist/* WNATIVE */.FX[chainId]) || currencyB && currencyB.equals(dist/* WNATIVE */.FX[chainId])));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(App/* AppBody */.j, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(App/* AppHeader */.t, {
                            title: ((ref4 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref4 === void 0 ? void 0 : ref4.symbol) && ((ref5 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref5 === void 0 ? void 0 : ref5.symbol) ? "".concat(currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].symbol, "-").concat(currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].symbol, " Stable LP") : t("Add Stable Liquidity"),
                            backTo: "/liquidity"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                gap: "20px",
                                children: [
                                    noLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* ColumnCenter */.lg, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                            variant: "warning",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        bold: true,
                                                        mb: "8px",
                                                        children: t("You are the first liquidity provider.")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        mb: "8px",
                                                        children: t("The ratio of tokens you add will set the price of this pool.")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        children: t("Once you are happy with the rate click supply to review.")
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                        showBUSD: true,
                                        onCurrencySelect: handleCurrencyASelect,
                                        zapStyle: "noZap",
                                        value: formattedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                                        onUserInput: onFieldAInput,
                                        onMax: function() {
                                            var ref;
                                            var ref1;
                                            onFieldAInput((ref1 = (ref = maxAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                        },
                                        showMaxButton: !atMaxAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                                        currency: currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                                        id: "add-liquidity-input-tokena",
                                        showCommonBases: true,
                                        commonBasesType: types/* CommonBasesType.LIQUIDITY */.L0.LIQUIDITY
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* ColumnCenter */.lg, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                            width: "16px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                        showBUSD: true,
                                        onCurrencySelect: handleCurrencyBSelect,
                                        zapStyle: "noZap",
                                        value: formattedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                                        onUserInput: onFieldBInput,
                                        onMax: function() {
                                            var ref;
                                            var ref1;
                                            onFieldBInput((ref1 = (ref = maxAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                        },
                                        showMaxButton: !atMaxAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                                        currency: currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                                        id: "add-liquidity-input-tokenb",
                                        showCommonBases: true,
                                        commonBasesType: types/* CommonBasesType.LIQUIDITY */.L0.LIQUIDITY
                                    }),
                                    currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] && pairState !== usePairs/* PairState.INVALID */._G.INVALID && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* LightCard */.hl, {
                                            padding: "0px",
                                            borderRadius: "20px",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowBetween */.m0, {
                                                    padding: "1rem",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        fontSize: "14px",
                                                        children: noLiquidity ? t("Initial prices and pool share") : t("Prices and pool share")
                                                    })
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* LightCard */.hl, {
                                                    padding: "1rem",
                                                    borderRadius: "20px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddLiquidity_PoolPriceBar, {
                                                        currencies: currencies,
                                                        poolTokenPercentage: poolTokenPercentage,
                                                        noLiquidity: noLiquidity,
                                                        price: price
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                bold: true,
                                                fontSize: "12px",
                                                color: "secondary",
                                                children: t("Slippage Tolerance")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                bold: true,
                                                color: "primary",
                                                children: [
                                                    allowedSlippage / 100,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }),
                                    !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {}) : isWrongNetwork ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                        gap: "md",
                                        children: [
                                            shouldShowApprovalGroup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                                style: {
                                                    gap: "8px"
                                                },
                                                children: [
                                                    showFieldAApproval && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        onClick: approveACallback,
                                                        disabled: approvalA === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING,
                                                        width: "100%",
                                                        children: approvalA === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                                                            children: t("Enabling %asset%", {
                                                                asset: (ref6 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref6 === void 0 ? void 0 : ref6.symbol
                                                            })
                                                        }) : t("Enable %asset%", {
                                                            asset: (ref7 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref7 === void 0 ? void 0 : ref7.symbol
                                                        })
                                                    }),
                                                    showFieldBApproval && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        onClick: approveBCallback,
                                                        disabled: approvalB === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING,
                                                        width: "100%",
                                                        children: approvalB === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                                                            children: t("Enabling %asset%", {
                                                                asset: (ref8 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref8 === void 0 ? void 0 : ref8.symbol
                                                            })
                                                        }) : t("Enable %asset%", {
                                                            asset: (ref9 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref9 === void 0 ? void 0 : ref9.symbol
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
                                                variant: !isValid ? "danger" : "primary",
                                                onClick: function() {
                                                    if (expertMode) {
                                                        onAdd();
                                                    } else {
                                                        setLiquidityState({
                                                            attemptingTxn: false,
                                                            liquidityErrorMessage: undefined,
                                                            txHash: undefined
                                                        });
                                                        onPresentAddLiquidityModal();
                                                    }
                                                },
                                                disabled: buttonDisabled,
                                                children: errorText || t("Supply")
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            pair && !noLiquidity && pairState !== usePairs/* PairState.INVALID */._G.INVALID ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                style: {
                    minWidth: "20rem",
                    width: "100%",
                    maxWidth: "400px",
                    marginTop: "1rem"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionCard/* MinimalPositionCard */.WP, {
                    showUnwrapped: oneCurrencyIsWNATIVE,
                    pair: pair
                })
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/add/[[...currency]].tsx
















var AddLiquidityPage = function() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var native = (0,useNativeCurrency/* default */.Z)();
    var ref2;
    var ref3 = (0,_sliced_to_array/* default */.Z)(router.query.currency || [
        native.symbol,
        (ref2 = (ref = src/* CAKE */.cr[chainId]) === null || ref === void 0 ? void 0 : ref.address) !== null && ref2 !== void 0 ? ref2 : (ref1 = src/* USDC */.gn[chainId]) === null || ref1 === void 0 ? void 0 : ref1.address, 
    ], 2), currencyIdA = ref3[0], currencyIdB = ref3[1];
    var currencyA = (0,Tokens/* useCurrency */.U8)(currencyIdA);
    var currencyB = (0,Tokens/* useCurrency */.U8)(currencyIdB);
    var _ref = (0,useStableConfig/* default */.ZP)({
        tokenA: currencyA,
        tokenB: currencyB
    }), stableSwapConfig = _ref.stableSwapConfig, stableConfig = (0,_object_without_properties/* default */.Z)(_ref, [
        "stableSwapConfig"
    ]);
    (0,react.useEffect)(function() {
        if (!currencyIdA && !currencyIdB) {
            dispatch((0,actions/* resetMintState */.dA)());
        }
    }, [
        dispatch,
        currencyIdA,
        currencyIdB
    ]);
    return stableSwapConfig ? /*#__PURE__*/ (0,jsx_runtime.jsx)(useStableConfig/* StableConfigContext.Provider */.UA.Provider, {
        value: (0,_object_spread/* default */.Z)({
            stableSwapConfig: stableSwapConfig
        }, stableConfig),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddStableLiquidity, {
            currencyA: currencyA,
            currencyB: currencyB
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AddLiquidity, {
        currencyA: currencyA,
        currencyB: currencyB
    });
};
AddLiquidityPage.chains = wagmi/* CHAIN_IDS */.vo;
var __N_SSG = true;
/* harmony default export */ var _currency_ = (AddLiquidityPage);


/***/ }),

/***/ 6973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ maxAmountSpend; }
/* harmony export */ });
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90902);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92794);


/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */ function maxAmountSpend(currencyAmount) {
    var ref;
    if (!currencyAmount) return undefined;
    if ((ref = currencyAmount.currency) === null || ref === void 0 ? void 0 : ref.isNative) {
        if (_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.greaterThan */ .QA.greaterThan(currencyAmount.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz)) {
            return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyAmount.currency, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.subtract */ .QA.subtract(currencyAmount.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz));
        }
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyAmount.currency, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .BIG_INT_ZERO */ .iV);
    }
    return currencyAmount;
}


/***/ }),

/***/ 67252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19453);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78545);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardFooter = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5ed8a823-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardFooter.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardFooter);


/***/ }),

/***/ 20345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62923);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.71005 11.71L11.3001 14.3C11.6901 14.69 12.3201 14.69 12.7101 14.3L15.3001 11.71C15.9301 11.08 15.4801 10 14.5901 10H9.41005C8.52005 10 8.08005 11.08 8.71005 11.71Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1246,5931,4273,7116,8324,8934,4787,1171,9051,247,4286,5366,6071,9774,2888,179], function() { return __webpack_exec__(9388); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);